<template>
    <div class="choose-new-payout-method">
        <h1 class="choose-new-payout-method__heading">Select a Payout Method</h1>
        <g-base-box padding="none">
            <g-list size="large" :split="false">
                <template v-for="(action, key) in payoutMethods">
                    <g-option-list-item
                        v-if="!hiddenPayoutMethod(key)"
                        :key="key"
                        :icon-url="action.icon_url"
                        :title-text="action.label"
                        :help-text="action.help1"
                        :help-text2="action.help2"
                        :disabled="action.disabled"
                        padding="p-5"
                        @click="handleClick(key, action.disabled)"
                    />
                </template>
            </g-list>
        </g-base-box>
    </div>
</template>

<script>
    import {
        PAYOUT_METHODS_MENU,
        PAYOUT_METHOD_TYPE_GRIN_DEBIT_CARD,
        PAYOUT_METHOD_TYPE_CARD,
        PAYOUT_METHOD_TYPE_BANK_MANUAL,
        GRIN_CARD_STATUS_CANCELED
    } from '../../../../../app-v2/constants/payouts';
    import {
        EVENT_NAME_PAYOUTS_GRIN_PAY_SELECTED,
        EVENT_NAME_PAYOUTS_DEBIT_CARD_SELECTED,
        EVENT_NAME_PAYOUTS_MANUAL_ACH_SELECTED
    } from '../../../../../app-v2/constants/analytics-events';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import useWhiteLabeling from '../../../../composables/use-white-labeling';
    import useContactStore from '../../../../../stores/contact';

    export default {
        name: 'ChooseNewPayoutMethod',
        props: {
            payoutAccount: {
                type: Object,
                default: null
            }
        },

        setup(props, context) {
            const events = useEventTracking();
            const contact = useContactStore().data;

            const hiddenPayoutMethod = (key) => {
                const isManaged = contact.is_managed;
                if (key === PAYOUT_METHOD_TYPE_GRIN_DEBIT_CARD) {
                    if (
                        props.payoutAccount?.payout_card &&
                        props.payoutAccount?.payout_card?.status !== GRIN_CARD_STATUS_CANCELED
                    ) {
                        return true;
                    }
                    if (isManaged) {
                        return true;
                    }
                }

                return false;
            };

            const handleClick = (method, disabled = false) => {
                if (disabled === true) {
                    return;
                }

                if (method === PAYOUT_METHOD_TYPE_GRIN_DEBIT_CARD) {
                    events.trackEvent(EVENT_NAME_PAYOUTS_GRIN_PAY_SELECTED, getEventPayload());
                } else if (method === PAYOUT_METHOD_TYPE_CARD) {
                    events.trackEvent(EVENT_NAME_PAYOUTS_DEBIT_CARD_SELECTED, getEventPayload());
                } else if (method === PAYOUT_METHOD_TYPE_BANK_MANUAL) {
                    events.trackEvent(EVENT_NAME_PAYOUTS_MANUAL_ACH_SELECTED, getEventPayload());
                }

                context.emit('payoutmethod', method);
            };

            const getEventPayload = () => {
                return {
                    contact_id: contact.id,
                    is_whitelabled: useWhiteLabeling().isWhiteLabeled(),
                    has_pending_payout: contact.has_pending_payout,
                    has_additional_payout_method: props.payoutAccount?.external_account?.payout_methods.length > 0
                };
            };

            return {
                payoutMethods: PAYOUT_METHODS_MENU,
                hiddenPayoutMethod,
                handleClick
            };
        }
    };
</script>

<style lang="scss">
    .choose-new-payout-method {
        font-family: Inter, sans-serif;
        padding: 24px;

        &__heading {
            font-size: 1.5rem;
            line-height: 2.25rem;
            text-align: center;
        }
    }

    @media (max-width: $g-screen-size-xs) {
        .choose-new-payout-method__heading {
            font-size: 16px;
        }
        .choose-new-payout-method img {
            height: 60px;
            width: 60px;
        }
    }
    @media (max-width: 320px) {
        .choose-new-payout-method.g-text-title {
            width: 107.5%;
        }
    }
</style>
